import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01cdb198"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-info-blocks" }
const _hoisted_2 = { class: "footer-info-block" }
const _hoisted_3 = { class: "sm:w-6rem xl:w-auto" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-s3 xl:mb-s4 caption uppercase" }, "BLUES price", -1))
const _hoisted_5 = {
  key: 1,
  class: "white-space-nowrap"
}
const _hoisted_6 = { class: "footer-info-block" }
const _hoisted_7 = { class: "sm:w-9rem xl:w-auto" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-s3 xl:mb-s4 caption uppercase" }, "Total supply", -1))
const _hoisted_9 = { class: "white-space-nowrap" }
const _hoisted_10 = {
  key: 0,
  class: "footer-info-block"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:w-6rem xl:w-auto" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "footer-info-block" }
const _hoisted_14 = { class: "sm:w-9rem xl:w-auto" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-s3 xl:mb-s4 caption uppercase" }, "Contract", -1))
const _hoisted_16 = { class: "flex flex-column" }
const _hoisted_17 = { class: "flex align-items-center mb-s2" }
const _hoisted_18 = { class: "mr-s2" }

import ExternalLink from '@/components/ExternalLink.vue';
import CopyIcon from '@/components/CopyIcon.vue';
import { useBluesPrice } from '@/composables/core/useBluesPrice';
import { getExplorerLink } from '@/composables/core/useExplorerLink';
import { useFormattedAddress } from '@/composables/utils/useFormattedAddress';
import { useInterval } from '@/composables/utils/useInterval';
import { TOTAL_BLUES_AMOUNT } from '@/constants/TOTAL_BLUES_AMOUNT';
import { UPDATE_BLUES_PRICE_TIMEOUT } from '@/constants/UPDATE_BLUES_PRICE_TIMEOUT';
import { bluesAddress } from '@/envinroment';
import { format } from '@/helpers/format';
import { onMounted } from 'vue';
import { useLayout } from '@/composables/core/useLayout';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { bluesPrice, updateBluesPrice, isBluesPriceLoading } = useBluesPrice();
useInterval(updateBluesPrice, UPDATE_BLUES_PRICE_TIMEOUT);
onMounted(updateBluesPrice);

const { isMobile } = useLayout();

const totalBluesSupply = format(TOTAL_BLUES_AMOUNT, 11);
const formattedBluesAddress = useFormattedAddress(bluesAddress!, {
  headLength: 8,
});
const explorerLink = getExplorerLink(bluesAddress!, 'token-transfers');

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_unref(isBluesPriceLoading))
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              class: "w-5"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString('$' + _unref(format)(_unref(bluesPrice).toFixed())), 1))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(totalBluesSupply)) + " BLUES", 1)
      ])
    ]),
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(formattedBluesAddress)), 1),
            _createVNode(CopyIcon, {
              data: _unref(bluesAddress),
              class: "text-gray"
            }, null, 8, ["data"])
          ]),
          _createVNode(ExternalLink, {
            label: "View in explorer",
            url: _unref(explorerLink),
            class: "text-primary"
          }, null, 8, ["url"])
        ])
      ])
    ])
  ]))
}
}

})